<template>
  <el-dialog class="updateImg"
             :visible.sync="updateImgVisible"
             :close-on-click-modal="false"
             @closed="closeDialog"
             width="1000px"
             :title="$t('goodsList.updateImg.dialogTitle')"
             :lock-scroll="false"
             :modal-append-to-body="false"
             append-to-body>
    <el-form label-width="100px" @keydown.enter.native.prevent>
      <el-form-item label-width="0">
        <div class="el-font-wg">Select from gallery</div>
        <div class="goods-list">
            <ul class="cards-wrap">
                <li :class="`card-item${item.select && ' card-item-select' || ''}`" v-for="(item, index) in goodsImagesObj" :key="index" style="width:120px;float:left" @click="chioceGoods(index)">
                    <el-image style="width: 100px; height: 100px" :src="item.src" :fit="fit"></el-image>
                    <div class="checker"><div class="tick">&nbsp;</div></div>
                </li>
            </ul>
        </div>
        <div class="el-font-wg"  style="width:100%">Custom upload image</div>
        <imgUpload :images="images"
                   @imagesChange="imagesChange"
                   :width="100"
                   :height="100"
                   :multiple="true"
                   :limit="1"
                   ref="uploadRef"
                   :type="type" />
      </el-form-item>
    </el-form>

    <span slot="footer"
          class="dialog-footer">
      <el-button size="small"
                 v-if="type!=='detail'"
                 type="primary"
                 @click="save">{{$t('goodsList.updateImg.save')}}</el-button>
      <el-button size="small"
                 v-else
                 @click="updateImgVisible = false">{{$t('goodsList.updateImg.close')}}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import imgUpload from "@/common/components/imgUpload";
import treeVue from '../../../../common/components/tree.vue';
import { nextTick } from 'vuedraggable';
export default {
    data() {
        return {
            images: [],
            goodsImagesObj:[],
            tableItemIndex: "",
            realImages:"",
        };
    },
    methods: {
        save() {
            this.$emit("update:tableItemIndex", this.tableItemIndex);
            if(this.realImages.length > 0){
                this.$emit("imgUrl", this.realImages);
            }else{
                console.log(this.images)
                this.$emit("imgUrl", this.images);
            }
            
            this.closeDialog();
        },
        closeDialog() {
            this.images = [];
            if (this.type !== "detail") {
                this.$refs.uploadRef.clear();
            }
            this.$emit("update:updateImgVisible", false);
            this.goodsImagesObj = [];
            this.realImages = [];
        },
        imagesChange(imgList) {
            this.images = imgList;
        },
        chioceGoods(i) {
            if(this.goodsImagesObj[i].select == true){
                this.goodsImagesObj[i].select = false;
                this.realImages = [];
                this.images = [];
            }else{
                this.goodsImagesObj.forEach((item, index) => {
                    this.goodsImagesObj[index].select = false;
                    if(i == index){
                        this.goodsImagesObj[index].select = true;
                        this.realImages = [item.src];
                    }
                }); 
            }
              
        }
    },
    components: {
        imgUpload: imgUpload,
    },
    props: {
        updateImgVisible: Boolean,
        tableItemIndex: Number,
        imagesList: Array,
        goodsImages:Array,
        type: String,
    },
    computed: {
        mixed() {
            const { tableItemIndex, updateImgVisible, imagesList, goodsImages } = this;
            return {
                tableItemIndex,
                updateImgVisible,
                imagesList,
                goodsImages,
            };
        },
    },
    watch: {
        mixed: {
            handler(newValue) {
                if (newValue.updateImgVisible) {
                    this.images = newValue.imagesList;
                    this.tableItemIndex = newValue.tableItemIndex;
                    let temp;
                    this.goodsImages.forEach((item, index) => {
                        if(this.images.length > 0 && this.images[0] == item){
                            temp = {"select":true,"src":item}
                        }else{
                            temp = {"select":false,"src":item}
                        }
                        this.goodsImagesObj.push(temp);
                    });
                }
            },
            deep: true,
            immediate: true,
        },
    },
};
</script>
<style lang="scss">
.updateImg {
    width: 100%;
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        float: left;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 148px;
        height: 148px;
        line-height: 148px;
        text-align: center;
    }
    .avatar {
        width: 148px;
        height: 148px;
        display: block;
    }
    .el-upload--picture-card {
        float: left !important;
        margin-right: 10px;
    }
    .uploadBox {
        .el-upload,
        .el-upload--text {
            width: 100%;
            height: 100%;
        }
        
    }
    .el-font-wg{
        font-weight: bold;
    }
    .goods-list {
        overflow-y: auto;
        max-height: 214px;

        .cards-wrap {
            //display: flex;
            flex-wrap: wrap;

            .card-item {
                position: relative;
                border: 1px solid #ededed;
                margin: 0 20px 10px 0;
                padding: 10px;
                box-sizing: border-box;
                transition: all 0.1s;
                position: relative;
                width: max-content!important;
                height: max-content!important;
                padding: 0;
                cursor: pointer;

                .el-image {
                    display: block;
                }

                .checker {
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    display: none;
                    width: 12px;
                    height: 12px;
                    border: 12px solid #635cff;
                    border-top-color: transparent;
                    border-left-color: transparent;
                    box-sizing: border-box;

                    .tick {
                        width: 6px;
                        height: 10px;
                        border: 2px solid transparent;
                        border-bottom-color: #fff;
                        border-right-color: #fff;
                        box-sizing: border-box;
                        transform: rotate(45deg) translate(-10%, -25%);
                    }
                }


                &:hover {
                    border-color: $color-primary;
                    box-shadow: 0 2px 3px 2px rgba(100, 100, 100, 0.1);
                }

                &.card-item-select {
                    border-color: $color-primary;
                    box-shadow: 0 2px 3px 2px rgba(100, 100, 100, 0.1);

                    .checker {
                    display: block; 
                    }
                }
            }

            
        }
    }
}
</style>